(function () {
  'use strict';
  if (window.ctAtlasReleasePolish) return;
  window.ctAtlasReleasePolish = true;
  function init() {
    document.querySelectorAll('.ct3-pdp-nav').forEach(function (nav) {
      var rail = nav.querySelector('.ct3-pdp-nav__links');
      if (!rail) return;
      var links = Array.from(rail.querySelectorAll('a[href^="#"]'));
      links.forEach(function (a) {
        var id = decodeURIComponent(a.hash.slice(1));
        if (!id || !document.getElementById(id)) { a.remove(); return; }
        a.addEventListener('focus', function () { reveal(a); });
        a.addEventListener('click', function () { reveal(a); });
      });
      var select = document.createElement('select');
      select.className = 'ct-release-section-select';
      select.setAttribute('aria-label', nav.getAttribute('aria-label') || 'On this page');
      links.filter(function(a){return a.isConnected;}).forEach(function(a){
        var option = document.createElement('option');
        option.value = a.getAttribute('href'); option.textContent = a.textContent.trim(); select.appendChild(option);
      });
      if (select.options.length) {
        rail.insertAdjacentElement('afterend', select); nav.classList.add('ct-release-select-nav');
        select.addEventListener('change', function(){
          var a = links.find(function(a){return a.getAttribute('href') === select.value;});
          if(a) a.click();
        });
      }
      function reveal(a) {
        var r = rail.getBoundingClientRect(), t = a.getBoundingClientRect();
        if (t.left < r.left || t.right > r.right) rail.scrollBy({left: t.left - r.left - 8, behavior: 'instant'});
      }
      var changes = new MutationObserver(function (records) {
        records.forEach(function (r) {
          var a = r.target;
          if (!a.matches('a')) return;
          if (a.classList.contains('is-on')) { a.setAttribute('aria-current', 'location'); select.value = a.getAttribute('href'); reveal(a); }
          else a.removeAttribute('aria-current');
        });
      });
      changes.observe(rail, {attributes: true, attributeFilter: ['class'], subtree: true});
    });
    var consent = document.querySelector('.ct3-consent, .cookie-disclaimer');
    if (consent) {
      function syncConsent() {
        var s = getComputedStyle(consent);
        document.documentElement.toggleAttribute('data-ct-consent-open', s.display !== 'none' && s.visibility !== 'hidden' && consent.getBoundingClientRect().height > 0);
      }
      new MutationObserver(syncConsent).observe(consent, {attributes: true, attributeFilter: ['style','class']});
      consent.addEventListener('click', function () { setTimeout(syncConsent, 0); });
      syncConsent();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
